const listaDeEmails = (state) => {
    return state.items;
}

const loadingEmails = (state) => {
    return state.carregando
}

const paginacao = (state) => {
    return state.paginacao
}

export {
    listaDeEmails,
    loadingEmails,
    paginacao
}
